import { getTranslateNsT } from "@/utils/getTranslateNsT";
import { VerificationStepsEnum } from "../constant";
const t = getTranslateNsT("childManager");

export const verificationCallBackFormConfig = [
  {
    title: t("dingtalk_subaccount_setting_aeskey"),
    field: "aesKey",
    isShowHeader: true,
    headerText: t("dingtalk_subaccount_create_text21"),
    headerTextNew: t("dingtalk_subaccount_create_text2"),
  },
  {
    title: t("dingtalk_subaccount_setting_token"),
    field: "token",
  },
  {
    title: t("dingtalk_subaccount_setting_requesturl"),
    field: "callbackUrl",
  },
  {
    title: t("dingtalk_subaccount_setting_domain"),
    field: "authCallbackUrl",
    headerText: t("dingtalk_subaccount_create_text31"),
    headerTextNew: t("dingtalk_subaccount_create_text3"),
    isShowHeader: true,
  },
  {
    title: t("dingtalk_subaccount_setting_application_url"),
    field: "appHomepageUrl",
    headerText: t("dingtalk_subaccount_create_text41"),
    headerTextNew: t("dingtalk_subaccount_create_text4"),
    isShowHeader: true,
  },
  {
    title: t("dingtalk_subaccount_setting_pc_url"),
    field: "pcHomepageUrl",
  },
];

export const verificationProgressConfig = [
  t("dingtalk_subaccount_setting_step1"),
  t("dingtalk_subaccount_setting_step4"),
  t("dingtalk_subaccount_setting_step2"),
];

export const verificationSettingBtnDeploy = new Map([
  [
    VerificationStepsEnum.STEP1,
    {
      preBtn: t("dingtalk_subaccount_setting_cancel_btn"),
      nextBtn: t("dingtalk_subaccount_setting_check_btn"),
      preEventName: "",
      nextEventName: "handleCheckValidate",
    },
  ],
  [
    VerificationStepsEnum.STEP2,
    {
      preBtn: t("dingtalk_subaccount_setting_cancel_btn"),
      nextBtn: t("dingtalk_subaccount_next_btn"),
      preEventName: "",
      nextEventName: "",
    },
  ],
  [
    VerificationStepsEnum.STEP3,
    {
      preBtn: t("dingtalk_subaccount_pre_btn"),
      nextBtn: t("dingtalk_subaccount_confirm_btn"),
      preEventName: "handleSetCurrentSteps",
      nextEventName: "handleSynchronousData",
    },
  ],
]);
